import { render, staticRenderFns } from "./FeeCfReportSection.vue?vue&type=template&id=3523cf94&scoped=true"
import script from "./FeeCfReportSection.vue?vue&type=script&lang=js"
export * from "./FeeCfReportSection.vue?vue&type=script&lang=js"
import style0 from "./list.css?vue&type=style&index=0&id=3523cf94&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3523cf94",
  null
  
)

export default component.exports